import PropTypes from 'prop-types';
import * as React from 'react';
import { useSnackbar } from 'notistack';
import { Box, Button } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationUtils } from '@jeremyling/react-material-ui-form-builder';
//  useWatch
import { useForm } from 'react-hook-form';
// project import
import withLoader from 'hoc/witLoader';
import { ActionCloseReason } from 'constants/CloseReasonTypes';
import FormModal from 'components/modal/FormModal';
import { TypeMode } from 'constants/TypeMode';
import CommitButton from './buttons/CommitButton';

const StandardModalForm = ({
    formConfig,
    mode,
    defaultValue,
    onClose,
    onSubmit,
    children,
    open = false,
    maxWidth,
    title,
}) => {
    let schema = React.useMemo(() => {
        return validationUtils.getFormSchema(formConfig[0]?.config());
    }, [formConfig]);

    const methods = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        resolver: yupResolver(schema),
        defaultValues: defaultValue,
    });

    // React.useEffect(() => {
    //     const values = methods.getValues();
    //     methods.reset({ ...defaultValue, ...values });
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    // const w = useWatch({ control: methods.control });

    const { enqueueSnackbar } = useSnackbar();

    const handleClose = action => {
        onClose(action);
        resetToDefaults();
    };

    const resetToDefaults = () => {
        methods.reset(defaultValue);
    };

    const handleCommit = async (posts, actions) => {
        await methods.trigger();
        // console.log(methods.formState);

        if (!methods.formState.isValid) {
            return;
        }
        actions.updateProps({ loading: true });
        posts = methods.getValues();
        onSubmit(
            posts,
            message => {
                enqueueSnackbar(message, { variant: 'success' });
                handleClose(ActionCloseReason.Submit);
                actions.updateProps({ loading: false });
            },
            (err, errMessage) => {
                const { errors, message } = err?.response?.data;
                if (message) {
                    enqueueSnackbar(message, { variant: 'error' });
                } else if (!errors || errors?.length === 0) {
                    enqueueSnackbar(err.message || errMessage, {
                        variant: 'error',
                    });
                }
                actions.updateProps({ loading: false });
            },
        );
    };

    return (
        <FormModal
            isOpen={open}
            title={title || ''}
            maxWidth={maxWidth || 'lg'}
            onClose={() => handleClose(ActionCloseReason.Close)}
            renderActions={() => (
                <>
                    <Box sx={{ paddingRight: 2 }}>
                        {mode === TypeMode.Create ? (
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() =>
                                    handleClose(ActionCloseReason.Close)
                                }
                                sx={{ marginRight: 3 }}
                            >
                                Cancel
                            </Button>
                        ) : (
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={resetToDefaults}
                                sx={{ marginRight: 3 }}
                            >
                                Reset
                            </Button>
                        )}
                        <CommitButton data={null} onCommit={handleCommit} />
                    </Box>
                </>
            )}
            closeIcon={true}
        >
            {open && (
                <form>
                    {children({
                        formConfig: formConfig,
                        methods: methods,
                        watch: null,
                        mode: mode,
                        defaultValue: defaultValue,
                    })}
                </form>
            )}
        </FormModal>
    );
};

StandardModalForm.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool,
    formConfig: PropTypes.arrayOf(
        PropTypes.shape({
            // list: PropTypes.array,
            config: PropTypes.func.isRequired,
        }),
    ).isRequired,
    defaultValue: PropTypes.object,
    mode: PropTypes.oneOf(['create', 'edit']),
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    maxWidth: PropTypes.string,
    children: PropTypes.func,
};

export default withLoader(StandardModalForm);
